export default "__VITE_ASSET__16bc20b4__"